/* projects/speaker-platform/src/app/organisms/statistic-filter/statistic-filter.component.scss */
/*# sourceMappingURL=statistic-filter.component-65MUJIW4.css.map */
